import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import {
  OPERATING_SYSTEM_SCREENSHOT_BUCKET,
  getOperatingSystemScreenshotStoragePath,
} from "@/lib/operating-systems";

const SIGNED_SCREENSHOT_TTL_SECONDS = 60 * 60;

export function useOperatingSystemScreenshotUrl(rawUrl: string | null): string | null {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const storagePath = getOperatingSystemScreenshotStoragePath(rawUrl);

  useEffect(() => {
    let cancelled = false;
    setSignedUrl(null);
    if (!storagePath) return undefined;

    supabase.storage
      .from(OPERATING_SYSTEM_SCREENSHOT_BUCKET)
      .createSignedUrl(storagePath, SIGNED_SCREENSHOT_TTL_SECONDS)
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.warn("Failed to sign operating system screenshot:", error.message);
          return;
        }
        setSignedUrl(data?.signedUrl ?? null);
      })
      .catch((error) => {
        if (!cancelled) {
          console.warn("Failed to sign operating system screenshot:", error);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [storagePath]);

  return storagePath ? signedUrl : rawUrl;
}
